"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var cardCouponApi = _interopRequireWildcard(require("@/api/cardCouponApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PriceRecordsDialog',
  data: function data() {
    return {
      visible: false,
      loading: false,
      records: [],
      parkingCardId: null
    };
  },
  methods: {
    open: function open(parkingCardId) {
      this.parkingCardId = parkingCardId;
      this.visible = true;
      this.loadRecords();
    },
    loadRecords: function loadRecords() {
      var _this = this;
      if (!this.parkingCardId) {
        this.records = [];
        return;
      }
      this.loading = true;
      cardCouponApi.getPriceAdjustmentRecords(this.parkingCardId).then(function (data) {
        _this.records = data || [];
        _this.loading = false;
      }).catch(function () {
        _this.$message.error('获取调价记录失败');
        _this.records = [];
        _this.loading = false;
      });
    },
    closeDialog: function closeDialog() {
      this.visible = false;
    }
  }
};